import { useEffect, useRef } from 'react'

export function useReaction(condition: boolean, effect: () => unknown) {
  const consitionHandledRef = useRef(false)

  useEffect(() => {
    if (condition && !consitionHandledRef.current) {
      effect()
      consitionHandledRef.current = true
    }

    if (!condition) {
      consitionHandledRef.current = false
    }
  }, [condition, effect])
}
